import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';
import axios from 'axios';
import { eraseAllCookies, eraseAllDomainCookies } from './utils/cookieutils';
import { HelmetProvider } from 'react-helmet-async'

axios.defaults.baseURL = '/api';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>
  ,
  document.getElementById("root")
    );


axios.interceptors.request.use(
  (config) => {
    try 
    {
      if (config.url.startsWith('/')) {
        const token = sessionStorage.getItem('jwttoken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      console.warn('URL parsing failed for', config.url);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)

    ) {
      // Clear any stored tokens
      //sessionStorage.removeItem('jwttoken');
      //localStorage.clear();
      sessionStorage.clear();
      //eraseAllCookies();
      //eraseAllDomainCookies({ path: "/", domain: ".wowleads.com" });
      // Redirect to login page (non-hook version)
      window.location.href = '/signin'; 
    }
    else if( error.response && error.response.status === 418)
    {
      
      if(!window.messageShown)
      {
        window.messageShown=1
        if(window.confirm("You have active session somewhere else do you want to continue here ?"))
        {
          //sessionStorage.setItem('isSessionExpiredMessageShown', '0');
          sessionStorage.clear();
          window.location.href = `/mmain`;
        }
        else
        {
          sessionStorage.clear();
          window.location.href = 'https://www.wowleads.com';  
        }
      } 

    }

    return Promise.reject(error);
  }
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
